import { init } from "../../../init-streaming";
import { JiraSoftwareFreePage } from "../../../pages/software/jira/free/jira-software-free-page";

init(JiraSoftwareFreePage);
